import {
    applyChainFilter,
    applyTurnoverFilter,
    applySalesSpaceFilter,
    applySegmentFilter,
    applyIncludeExcludeFilter
} from './filter-helpers';

/**
 * Applicera filters direkt på units baserat på salesDistrictFilters-objektet
 * Används för att applicera filters vid initial laddning utan att vänta på Filter-komponenterna
 * @param {Array} units - Units att filtrera
 * @param {Object} salesDistrictFilters - Filter-objekt från district
 * @param {string} type - District type ('retail' eller 'foodservice')
 * @returns {Array} - Filtrerade units
 */
const stripIncompleteUnits = list =>
    (list || []).filter(unit => {
        if (!unit) return false;

        const turnoverClassMissing =
            unit.turnoverClass === '' || unit.turnoverClass === null || typeof unit.turnoverClass === 'undefined';
        const turnoverValue = Number(unit.turnover);
        const turnoverMissing = Number.isNaN(turnoverValue) || turnoverValue === 0;
        const retailAreaValue = Number(unit.retailArea);
        const retailAreaMissing = Number.isNaN(retailAreaValue) || retailAreaValue === 0;

        const invalidTurnoverData = turnoverClassMissing && turnoverMissing;
        const invalidRetailData = turnoverClassMissing && retailAreaMissing;

        return !(invalidTurnoverData || invalidRetailData);
    });

export function applyFilters(units, salesDistrictFilters, type, originalUnits = units) {
    const sanitizedUnits = stripIncompleteUnits(units);
    const sanitizedOriginalUnits = stripIncompleteUnits(originalUnits);

    if (!salesDistrictFilters || sanitizedUnits.length === 0) {
        return sanitizedUnits;
    }

    let filteredUnits = [...sanitizedUnits];

    filteredUnits = applyChainFilter(filteredUnits, salesDistrictFilters.chains);
    filteredUnits = applyTurnoverFilter(filteredUnits, salesDistrictFilters.turnovers, type);
    filteredUnits = applySalesSpaceFilter(filteredUnits, salesDistrictFilters.salesSpaceGroups, type);
    filteredUnits = applySegmentFilter(filteredUnits, salesDistrictFilters.segments, type);
    filteredUnits = applyIncludeExcludeFilter(
        filteredUnits,
        salesDistrictFilters.unitsIncludeExclude,
        sanitizedOriginalUnits
    );

    return filteredUnits;
}

